/* eslint-disable */
function MinMaxInput(props) {
    const {
        id,
        value,
        handleMinMaxChange,
        notNegative = false,
        disabled = false,
        name,
        size = 'md',
    } = props;

    const handleChange = (name, value, id) => {
        const newValue = Number(value);
        // Don't allow negative numbers if notNegative is true
        if (notNegative && newValue < 0) {
            return;
        }

        // Handle empty or invalid input
        if (newValue === '' || isNaN(newValue)) {
            handleMinMaxChange(name, '', id);
            return;
        }

        handleMinMaxChange(name, newValue, id);
    };

    const heightClass = size === 'sm' ? 'h-8' : 'h-10';
    const buttonWidthClass = size === 'sm' ? 'w-8' : 'w-[4rem]';
    const inputWidthClass = size === 'sm' ? 'w-12' : 'w-[5rem]';
    const containerWidthClass = size === 'sm' ? 'w-28' : 'w-40';

    return (
        <div className={`flex items-center bg-white ${containerWidthClass} ${heightClass} border border-gray-200 rounded-md`}>
            <button
                type="button"
                onClick={() => {
                    if (!disabled) {
                        const currentValue = Number(value) || 0;
                        if (notNegative && currentValue <= 0) return;
                        handleMinMaxChange(name, currentValue - 1, id);
                    }
                }}
                disabled={disabled}
                className={`${buttonWidthClass} h-full flex items-center justify-center ${size === 'sm' ? 'text-lg' : 'text-2xl'} hover:bg-gray-100`}
            >
                -
            </button>
            <input
                type="number"
                value={value}
                onChange={(e) => handleChange(name, e.target.value, id)}
                disabled={disabled}
                className={`${inputWidthClass} h-full text-center ${size === 'sm' ? 'text-sm' : ''}`}
                name={name}
                id={id}
            />
            <button
                type="button"
                onClick={() => {
                    if (!disabled) {
                        const currentValue = Number(value) || 0;
                        handleMinMaxChange(name, currentValue + 1, id);
                    }
                }}
                disabled={disabled}
                className={`${buttonWidthClass} h-full flex items-center justify-center ${size === 'sm' ? 'text-lg' : 'text-2xl'} hover:bg-gray-100`}
            >
                +
            </button>
        </div>
    );
}

export default MinMaxInput;
